import { useLocale } from 'use-intl'
import {
  footballCoreHref,
  footballCoreLocale,
} from '~/lib/navigation/football-core'

export interface ComplianceNoticeProps {
  compact?: boolean
}

const copy = {
  'en': {
    risk: 'BallPeek provides football monitoring and descriptive context, not betting advice or recommendations. Market data may be delayed or incomplete, and outcomes are never guaranteed.',
    terms: 'Terms',
    privacy: 'Privacy',
    disclaimer: 'Disclaimer',
    ariaLabel: 'Legal information',
  },
  'zh-CN': {
    risk: 'BallPeek 提供足球监测与描述性背景资料，不提供投注建议或推荐。市场数据可能延迟或不完整，比赛结果不受保证。',
    terms: '服务条款',
    privacy: '隐私政策',
    disclaimer: '免责声明',
    ariaLabel: '法律信息',
  },
} as const

export function ComplianceNotice({ compact = false }: ComplianceNoticeProps) {
  const locale = footballCoreLocale(useLocale())
  const text = copy[locale]
  const linkClassName = 'inline-flex min-h-11 min-w-11 items-center justify-center px-2 underline decoration-divider underline-offset-4 hover:text-foreground'

  return (
    <div
      role="note"
      className={compact
        ? 'border-t border-divider/60 px-4 py-4 text-xs text-muted lg:px-6'
        : 'py-5 text-xs text-muted'}
    >
      <div className={compact ? 'mx-auto flex max-w-7xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between' : 'flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'}>
        <p data-descriptive-disclaimer className="max-w-[72ch] leading-5">{text.risk}</p>
        <nav aria-label={text.ariaLabel} className="flex shrink-0 flex-wrap gap-x-4 gap-y-2 font-semibold">
          <a className={linkClassName} href={footballCoreHref(locale, '/legal/terms')}>
            {text.terms}
          </a>
          <a className={linkClassName} href={footballCoreHref(locale, '/legal/privacy')}>
            {text.privacy}
          </a>
          <a className={linkClassName} href={footballCoreHref(locale, '/legal/disclaimer')}>
            {text.disclaimer}
          </a>
        </nav>
      </div>
    </div>
  )
}
